<template>
    <span>
        <svg class="h-full w-4" viewBox="0 0 40 80" fill="none"  preserveAspectRatio="none"><path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round"></path></svg>
    </span>
</template>